import styled from "styled-components";
import {WHITE} from "../../../../../../../../../../_shared/colors";

export const StudioPreviewWrapper = styled.div`
  height: calc(100vh - 57px);
  background-color: ${WHITE};
  position: relative;
`;
